"use client";

import { ResumeCertificationsTabV2 } from "./ResumeCertificationsTabV2";
import { ResumeExperienceTabV2 } from "./ResumeExperienceTabV2";
import { ResumeIndustriesTabV2 } from "./ResumeIndustriesTabV2";
import { ResumeProjectsTabV2 } from "./ResumeProjectsTabV2";
import { ResumeSkillsTabV2 } from "./ResumeSkillsTabV2";

export type ProfileResumeTabV2 = "experiences" | "certifications" | "skills" | "fields" | "project";

export interface ProfileResumeBuilderV2Props {
  activeTab: ProfileResumeTabV2;
}

/**
 * V2 entry point for Profile > Crear resumen.
 *
 * The tab switch stays in ProfilePageV2; this component owns the tab body
 * resolution and isolates the ongoing v2 migration of each resume subdomain.
 */
export function ProfileResumeBuilderV2({ activeTab }: ProfileResumeBuilderV2Props) {
  if (activeTab === "certifications") return <ResumeCertificationsTabV2 />;
  if (activeTab === "skills") return <ResumeSkillsTabV2 />;
  if (activeTab === "fields") return <ResumeIndustriesTabV2 />;
  if (activeTab === "project") return <ResumeProjectsTabV2 />;
  return <ResumeExperienceTabV2 />;
}
